module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/raleway-light.7f8751a6.svg";